module.exports = __webpack_public_path__ + "static/media/The True Jewel for Basmati Importers.e2162f6c.png";